import {Navbar} from "../components/Navbar/Mobile";
import {Navbar as DesktopNavbar} from "../components/Navbar/Desktop/Navbar";
import flybigLogoSearchNav from "../assets/svgs/flybigLogoSearchNav.svg";
import React from "react";
import {useWindowSize} from "../utils/utils";
import {colorPalette} from "../theme/color-palette";
import {useNavigate} from "react-router-dom";

const PassengerCharter = () => {
    const { white500, primary500 } = colorPalette;
    const navigate = useNavigate();

    const [innerWidth] = useWindowSize();
    const isMobile = innerWidth < 640;
    return (
        <div className="h-screen">
            {isMobile ? (
                <Navbar
                    color={white500}
                    bgColor={primary500}
                    label={"Passenger Charted"}
                    showMenu={false}
                    onClose={() => navigate.go(-1)}
                />
            ) : (
                <div className='nav-container-search-page bg-primary'>
                    <DesktopNavbar
                        logo={flybigLogoSearchNav}
                        customClass='navbar-search'
                    />
                </div>
            )}

            <iframe
                src="https://flybigassets.s3.ap-south-1.amazonaws.com/admin-web/Passenger+Charted"
                width="100%"
                height="100%"
                title="PDF Viewer"
                style={{border: "none"}}
                loading="lazy"
            >
                This browser does not support PDFs. Please download the PDF to view it:
                <a href="https://flybigassets.s3.ap-south-1.amazonaws.com/admin-web/Passenger+Charted">Download PDF</a>.
            </iframe>

        </div>
    );
};

export default PassengerCharter;